// @ts-ignore
import Cookies from 'js-cookie'
import { userStore } from "@/stores/userStore"
import type { Router } from 'vue-router'
declare global {
    interface Window {
        app: any;
    }
}

let router: Router | null = null

Cookies.defaults = {
    path: '/'
}

export function setRouter(r: Router) {
    router = r
}

export const authService = {
    isAuthenticated: function () {
        return Cookies.get('token') !== undefined
    },
    getToken: function () {
        if(Cookies.get('masqueraded') !== undefined) {
            return Cookies.get('masqueraded')
        }
        return Cookies.get('token')
    },
    getAuthId: function () {
        const ustore = userStore()
        return ustore.userdata.id ?? ''
    },
    login: function (pinia: any, response: any, remember: boolean) {
        const options = remember ? {expires: 60 * 60 * 24 * 30} : {expires: 60 * 60 * 24};
        Cookies.set('token', response.data.token, options)
    },
    logout: async function () {
        const ustore = userStore()
        console.log('Logging out...')

        // Regular cleanup
        Cookies.remove('token')
        Cookies.remove('masqueraded')
        if (ustore.clear) {
            ustore.clear()
        }
        window.localStorage.clear()

        if (router) {
            await router.push({ name: 'home' })
        }
    },
    masquerade: async function (token: any) {
        const ustore = userStore()
        Cookies.set('masqueraded', token)
        if (ustore.clear) {
            ustore.clear()
        }

        if (router) {
            await router.push({ name: 'home' })
        }
    },
    isMasqueraded: function () {
        return Cookies.get('masqueraded') !== undefined
    },
    getMasqueradedToken: function () {
        return Cookies.get('masqueraded')
    },
    unmask: async function () {
        const ustore = userStore()
        Cookies.remove('masqueraded')
        if (ustore.clear) {
            ustore.clear()
        }
        if (ustore.loadProfile) {
            await ustore.loadProfile()
        }

        if (router) {
            await router.push({ name: 'home' })
        }
    }
}
